import { render, staticRenderFns } from "./AppNav.vue?vue&type=template&id=af64b58e&"
import script from "./AppNav.vue?vue&type=script&lang=js&"
export * from "./AppNav.vue?vue&type=script&lang=js&"
import style0 from "./AppNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports